import{coreDefaultTheme as e}from"@kite-js/theme";export default function(t){return t.theme?t.theme:e}
